import { Component, h, Prop } from '@stencil/core';
import 'material-icons/iconfont/material-icons.css';

@Component({
  tag: 'signet-icon-only',
  styleUrl: 'signet-button-icon-only.scss',
  shadow: false,
})
export class SignetIconOnly {
  /**
   * Number of notifications
   */
  @Prop() notificationCount: string;

  /**
   * Insert the class name of the material design Icon you want to design, select Icons from
   */
  @Prop() icon = 'low_priority';

  // private getNotificationCount(): string {
  //   return (
  //     (this.notificationCount || '0' )
  //   );
  // }

  // private materialIconClass(): string {
  //   return (
  //     (this.materialIcon || 'account_circle' )
  //   );
  // }

  // $2,500 USD  per month.

  private createRipple(event) {
    const button = event.currentTarget;

    const circle = document.createElement('span');
    const diameter = Math.max(button.clientWidth, button.clientHeight);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${event.clientX - button.offsetLeft - radius}px`;
    circle.style.top = `${event.clientY - button.offsetTop - radius}px`;
    circle.classList.add('ripple');

    const ripple = button.getElementsByClassName('ripple')[0];

    if (ripple) {
      ripple.remove();
    }

    button.appendChild(circle);
  }

  render() {
    return (
      <button onClick={this.createRipple} class="button-icon">
        <span class="button-icon-span">
          {/* Material Icon */}
          <span class="material-icons">{this.icon}</span>
          {/* Notifications Count */}
          {this.notificationCount && (
            <span class="notification-counter">{this.notificationCount}</span>
          )}
        </span>
      </button>
    );
  }
}
